<div class="bizdev-home">
    <p-toast></p-toast>

    <!-- Header Row -->
    <div class="bh-header">
        <div class="bh-greeting">
            <h1 class="bh-greeting-text">
                Welcome back<span *ngIf="currentUserName">, {{ currentUserName }}</span>
            </h1>
            <span class="bh-date">{{ today | date:'EEEE, MMMM d, yyyy' }}</span>
        </div>
        <div class="bh-header-actions">
            <a routerLink="/bizdev-dashboard" mat-stroked-button class="bh-header-link">Ops Dashboard</a>
            <a routerLink="/owner-lead-profile-list" mat-raised-button color="primary" class="bh-header-link">+ New Lead</a>
        </div>
    </div>

    <!-- Sales Productivity Summary -->
    <div class="bh-section">
        <div class="bh-section-header">
            <h2 class="bh-section-title">Sales Productivity</h2>
            <div class="bh-section-actions">
                <!-- Task I: View Toggle -->
                <div class="bh-view-toggle">
                    <button class="bh-toggle-btn" [class.bh-toggle-active]="viewMode === 'me'" (click)="setViewMode('me')">Me</button>
                    <button class="bh-toggle-btn" [class.bh-toggle-active]="viewMode === 'myteam'" (click)="setViewMode('myteam')">My Team</button>
                    <button class="bh-toggle-btn" [class.bh-toggle-active]="viewMode === 'all'" (click)="setViewMode('all')">All</button>
                </div>
                <button mat-stroked-button (click)="loadProductivityReport()" [disabled]="productivityLoading" class="bh-action-btn">
                    <i class="pi pi-refresh"></i> Refresh
                </button>
                <button mat-raised-button color="accent" (click)="emailProductivityReport()" [disabled]="emailLoading" class="bh-action-btn">
                    <i class="pi pi-envelope"></i>
                    {{ emailLoading ? 'Sending...' : 'Email to me' }}
                </button>
            </div>
        </div>

        <div class="bh-productivity-card">
            <div *ngIf="productivityLoading" class="bh-skeleton-block">
                <div class="bh-skeleton-line bh-skeleton-wide"></div>
                <div class="bh-skeleton-line bh-skeleton-med"></div>
                <div class="bh-skeleton-line bh-skeleton-wide"></div>
                <div class="bh-skeleton-line bh-skeleton-short"></div>
            </div>
            <div *ngIf="!productivityLoading && productivityError" class="bh-error-state">
                <i class="pi pi-exclamation-triangle"></i>
                <span>Could not load the productivity report. Check that the backend is running, then click Refresh.</span>
            </div>
            <div *ngIf="!productivityLoading && !productivityError && productivityHtml"
                 class="bh-productivity-html"
                 (click)="onProductivityHtmlClick($event)"
                 [innerHTML]="productivityHtml">
            </div>
        </div>
    </div>

    <!-- 2x2 Tile Grid -->
    <div class="bh-tiles">

        <!-- Tile A: Follow-ups (Owner Lead Tasks) -->
        <div class="bh-tile">
            <div class="bh-tile-header">
                <i class="pi pi-calendar-times bh-tile-icon"></i>
                <h3 class="bh-tile-title">Follow-ups</h3>
            </div>
            <div class="bh-tile-body">
                <div *ngIf="followupTasksLoading" class="bh-loading-row">
                    <mat-spinner diameter="24"></mat-spinner>
                    <span>Loading...</span>
                </div>
                <div *ngIf="!followupTasksLoading && followupTasksError" class="bh-error-state">
                    <i class="pi pi-exclamation-triangle"></i>
                    <span>Could not load follow-up tasks.</span>
                </div>
                <div *ngIf="!followupTasksLoading && !followupTasksError && followupTasks.length === 0" class="bh-empty-state">
                    No open follow-ups.
                </div>
                <ul *ngIf="!followupTasksLoading && !followupTasksError && followupTasks.length > 0" class="bh-lead-list">
                    <li *ngFor="let task of followupTasks" class="bh-lead-row" (click)="navigateTo('/tasks')">
                        <span class="bh-lead-name">{{ task.name }}</span>
                        <span class="bh-lead-meta">
                            <span class="bh-badge">{{ getTaskStatusLabel(task.status) }}</span>
                            <span *ngIf="task.dateDue" class="bh-date-small">Due {{ task.dateDue | date:'MMM d' }}</span>
                        </span>
                    </li>
                </ul>
                <a routerLink="/tasks" class="bh-view-all">View all tasks &rarr;</a>
            </div>
        </div>

        <!-- Tile B: Owner Communications Inbox -->
        <div class="bh-tile">
            <div class="bh-tile-header">
                <i class="pi pi-inbox bh-tile-icon"></i>
                <h3 class="bh-tile-title">Owner Leads — Last 30 Days</h3>
            </div>
            <div class="bh-tile-body">
                <div *ngIf="ownerLeadsLoading" class="bh-loading-row">
                    <mat-spinner diameter="24"></mat-spinner>
                    <span>Loading...</span>
                </div>
                <div *ngIf="!ownerLeadsLoading && recentOwnerLeads.length === 0" class="bh-empty-state">
                    No owner leads in the last 30 days.
                </div>
                <ul *ngIf="!ownerLeadsLoading && recentOwnerLeads.length > 0" class="bh-lead-list">
                    <li *ngFor="let lead of recentOwnerLeads" class="bh-lead-row" (click)="navigateTo('/owner-lead-profile-list')">
                        <span class="bh-lead-name">{{ lead.firstName }} {{ lead.lastName }}</span>
                        <span class="bh-lead-meta">
                            <span class="bh-badge" [class.bh-badge-green]="lead.leadStatus === 4"
                                  [class.bh-badge-red]="lead.leadStatus === 5">
                                {{ getLeadStatusLabel(lead.leadStatus) }}
                            </span>
                            <span class="bh-date-small">{{ lead.lastUpdate | date:'MMM d' }}</span>
                        </span>
                    </li>
                </ul>
                <a routerLink="/owner-lead-profile-list" class="bh-view-all">View all leads &rarr;</a>
            </div>
        </div>

        <!-- Tile C: Recent Proforma Activity -->
        <div class="bh-tile">
            <div class="bh-tile-header">
                <i class="pi pi-chart-line bh-tile-icon"></i>
                <h3 class="bh-tile-title">Proforma Activity</h3>
            </div>
            <div class="bh-tile-body">
                <div *ngIf="proformaActivityLoading" class="bh-loading-row">
                    <mat-spinner diameter="24"></mat-spinner>
                    <span>Loading...</span>
                </div>
                <div *ngIf="!proformaActivityLoading && proformaActivityError" class="bh-placeholder-msg">
                    <i class="pi pi-info-circle"></i>
                    Backend filter by eventCategory=BIZDEV not yet confirmed. Check AppEventController for filter support, or add it to enable this tile.
                </div>
                <ng-container *ngIf="!proformaActivityLoading && !proformaActivityError">
                    <div class="bh-proforma-sub">
                        <span class="bh-sub-label"><i class="pi pi-eye"></i> Recently Viewed</span>
                        <div *ngIf="recentProformaViews.length === 0" class="bh-empty-state">No views recorded.</div>
                        <ul *ngIf="recentProformaViews.length > 0" class="bh-activity-list">
                            <li *ngFor="let ev of recentProformaViews" class="bh-activity-row" (click)="navigateToProforma(ev)">
                                <span class="bh-activity-conf">{{ extractConfId(ev.metadata) || 'Proforma' }}</span>
                                <span class="bh-date-small">{{ ev.clickedAt | date:'MMM d, h:mm a' }}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="bh-proforma-sub">
                        <span class="bh-sub-label"><i class="pi pi-send"></i> Recently Sent</span>
                        <div *ngIf="recentProformaSent.length === 0" class="bh-empty-state">No sends recorded.</div>
                        <ul *ngIf="recentProformaSent.length > 0" class="bh-activity-list">
                            <li *ngFor="let ev of recentProformaSent" class="bh-activity-row" (click)="navigateToProforma(ev)">
                                <span class="bh-activity-conf">{{ extractConfId(ev.metadata) || 'Proforma' }}</span>
                                <span class="bh-date-small">{{ ev.clickedAt | date:'MMM d, h:mm a' }}</span>
                            </li>
                        </ul>
                    </div>
                </ng-container>
                <a routerLink="/proforma-list" class="bh-view-all">View all proformas &rarr;</a>
            </div>
        </div>

        <!-- Tile D: Quick Links -->
        <div class="bh-tile">
            <div class="bh-tile-header">
                <i class="pi pi-th-large bh-tile-icon"></i>
                <h3 class="bh-tile-title">Quick Links</h3>
            </div>
            <div class="bh-tile-body">
                <div class="bh-quick-links-grid">
                    <button *ngFor="let link of quickLinks"
                            mat-raised-button
                            class="bh-quick-link-btn"
                            (click)="navigateTo(link.route)">
                        <i [class]="link.icon + ' bh-ql-icon'"></i>
                        <span class="bh-ql-label">{{ link.label }}</span>
                    </button>
                </div>
            </div>
        </div>

    </div>

    <!-- Task H: Pipeline Funnel — full-width section below tile grid -->
    <div class="bh-section bh-funnel-section">
        <div class="bh-section-header">
            <h2 class="bh-section-title">Pipeline Funnel — All Leads</h2>
            <button mat-stroked-button (click)="loadPipelineFunnel()" [disabled]="funnelLoading" class="bh-action-btn">
                <i class="pi pi-refresh"></i> Refresh
            </button>
        </div>

        <div class="bh-productivity-card">
            <!-- Loading -->
            <div *ngIf="funnelLoading" class="bh-skeleton-block">
                <div class="bh-skeleton-line bh-skeleton-wide"></div>
                <div class="bh-skeleton-line bh-skeleton-med"></div>
            </div>

            <!-- Error -->
            <div *ngIf="!funnelLoading && funnelError" class="bh-error-state">
                <i class="pi pi-exclamation-triangle"></i>
                <span>Could not load pipeline data.</span>
            </div>

            <!-- Funnel chart -->
            <ng-container *ngIf="!funnelLoading && !funnelError">
                <div class="bh-funnel-total">{{ funnelTotal }} total leads</div>
                <div class="bh-funnel-chart">
                    <ng-container *ngFor="let stage of funnelStages; let i = index; let last = last">
                        <div class="bh-funnel-row">
                            <div class="bh-funnel-label">{{ stage.label }}</div>
                            <div class="bh-funnel-bar-wrap">
                                <div class="bh-funnel-bar"
                                     [style.width]="funnelBarWidth(stage)"
                                     [style.background]="stage.color">
                                </div>
                            </div>
                            <div class="bh-funnel-count">{{ stage.count }}</div>
                        </div>
                        <div *ngIf="!last" class="bh-funnel-conversion">
                            <i class="pi pi-arrow-down bh-funnel-arrow"></i>
                            <span class="bh-funnel-pct">{{ funnelConversion(i) }}</span>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>

</div>
